"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentForTeamsProjectTypeNode = exports.llmServiceNode = exports.aiAgentNode = exports.customCopilotRagNode = void 0;
const localizeUtils_1 = require("../../../common/localizeUtils");
const questionNames_1 = require("../../questionNames");
const CapabilityOptions_1 = require("./CapabilityOptions");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const teamsProjectTypeNode_1 = require("./teamsProjectTypeNode");
function customCopilotRagNode() {
    return {
        condition: { equals: CapabilityOptions_1.CustomCopilotCapabilityOptions.customCopilotRag().id },
        data: {
            type: "singleSelect",
            name: questionNames_1.QuestionNames.CustomCopilotRag,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRag.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRag.placeholder"),
            staticOptions: [
                CapabilityOptions_1.CustomCopilotRagOptions.customize(),
                CapabilityOptions_1.CustomCopilotRagOptions.azureAISearch(),
                CapabilityOptions_1.CustomCopilotRagOptions.customApi(),
                CapabilityOptions_1.CustomCopilotRagOptions.microsoft365(),
            ],
            default: CapabilityOptions_1.CustomCopilotRagOptions.customize().id,
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [(0, teamsProjectTypeNode_1.apiSpecNode)({ equals: CapabilityOptions_1.CustomCopilotRagOptions.customApi().id })],
    };
}
exports.customCopilotRagNode = customCopilotRagNode;
function aiAgentNode() {
    return {
        condition: { equals: CapabilityOptions_1.CustomCopilotCapabilityOptions.aiAgent().id },
        data: {
            type: "singleSelect",
            name: questionNames_1.QuestionNames.CustomCopilotAssistant,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistant.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistant.placeholder"),
            staticOptions: [
                CapabilityOptions_1.CustomCopilotAssistantOptions.new(),
                CapabilityOptions_1.CustomCopilotAssistantOptions.assistantsApi(),
            ],
            default: CapabilityOptions_1.CustomCopilotAssistantOptions.new().id,
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
    };
}
exports.aiAgentNode = aiAgentNode;
function llmServiceNode(condition) {
    return {
        condition: condition,
        data: {
            type: "singleSelect",
            name: questionNames_1.QuestionNames.LLMService,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.placeholder"),
            staticOptions: [
                {
                    id: "llm-service-azure-openai",
                    label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceAzureOpenAIOption.label"),
                    detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceAzureOpenAIOption.detail"),
                },
                {
                    id: "llm-service-openai",
                    label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceOpenAIOption.label"),
                    detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceOpenAIOption.detail"),
                },
            ],
            skipSingleOption: true,
            default: "llm-service-azure-openai",
        },
        children: [
            {
                condition: { equals: "llm-service-azure-openai" },
                data: {
                    type: "text",
                    password: true,
                    name: questionNames_1.QuestionNames.AzureOpenAIKey,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIKey.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIKey.placeholder"),
                },
                children: [
                    {
                        condition: (inputs) => {
                            var _a;
                            return ((_a = inputs[questionNames_1.QuestionNames.AzureOpenAIKey]) === null || _a === void 0 ? void 0 : _a.length) > 0;
                        },
                        data: {
                            type: "text",
                            name: questionNames_1.QuestionNames.AzureOpenAIEndpoint,
                            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIEndpoint.title"),
                            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIEndpoint.placeholder"),
                        },
                        children: [
                            {
                                condition: (inputs) => {
                                    var _a;
                                    return ((_a = inputs[questionNames_1.QuestionNames.AzureOpenAIEndpoint]) === null || _a === void 0 ? void 0 : _a.length) > 0;
                                },
                                data: {
                                    type: "text",
                                    name: questionNames_1.QuestionNames.AzureOpenAIDeploymentName,
                                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIDeploymentName.title"),
                                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIDeploymentName.placeholder"),
                                },
                            },
                        ],
                    },
                ],
            },
            {
                condition: { equals: "llm-service-openai" },
                data: {
                    type: "text",
                    password: true,
                    name: questionNames_1.QuestionNames.OpenAIKey,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.openAIKey.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.openAIKey.placeholder"),
                },
            },
        ],
    };
}
exports.llmServiceNode = llmServiceNode;
function agentForTeamsProjectTypeNode() {
    return {
        // project-type = Agent for Teams
        condition: { equals: ProjectTypeOptions_1.ProjectTypeOptions.agentForTeamsOptionId },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.agentForTeams.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.CustomCopilotCapabilityOptions.basicChatbot(),
                CapabilityOptions_1.CustomCopilotCapabilityOptions.customCopilotRag(),
                CapabilityOptions_1.CustomCopilotCapabilityOptions.aiAgent(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [customCopilotRagNode(), aiAgentNode(), llmServiceNode()],
    };
}
exports.agentForTeamsProjectTypeNode = agentForTeamsProjectTypeNode;
//# sourceMappingURL=agentForTeamsNode.js.map